<template>
  <v-card>
    <div class="d-flex flex-no-wrap justify-space-between">
      <div>
        <v-card-title>
           Rufgruppen beantragen
        </v-card-title>

        <v-card-subtitle>Digital- oder Anlaoggruppen für Übungsdienst beantragen</v-card-subtitle>

        <v-card-actions>
          <v-btn
            class="ml-2 mt-5"
            outlined
            rounded
            small
            :loading="creating"
            @click="create"
          >
            Ticket erstellen
          </v-btn>
        </v-card-actions>
      </div>

      <v-avatar
        class="ma-3"
        size="125"
        tile
      >
        <v-img src="@/assets/elw_funkmast.png"></v-img>
      </v-avatar>
    </div>
  </v-card>
</template>


<script>
export default {
  name: "Rufgruppe_beantragen",
  data: () => ({
    creating: false,
  }),
  methods: {
    async create() {
      if (this.creating) return
      this.creating = true
      try {
        const wf = this.$store.state.ticketsystem.workflows.find(
          w => (w.name || "").toLowerCase().includes("rufgruppe")
        )
        const payload = {
          title: "Rufgruppe beantragen",
          text: "Wir benötigen eine TMO-Rufgruppe, vorzugsweise Zus_Arb_#1.",
        }
        if (wf) payload.workflow_blueprint_id = wf.id
        const data = await this.$store.dispatch("update", {
          payload_type: "POST",
          context: "/tickets",
          payload,
        })
        const id = data && data.ticket && data.ticket.id
        this.$store.commit("add_push_notification", {
          text: 'Ticket „Rufgruppe beantragen" wurde erstellt.',
          live_time: 6000,
        })
        if (id != null) this.$emit("open-ticket", id)
      } finally {
        this.creating = false
      }
    },
  },
  mounted() {
    if (this.$store.state.ticketsystem.workflows.length === 0) {
      this.$store.dispatch("update", { context: "/workflows" })
    }
  },
};
</script>



<style scoped>

</style>
